{
    "name": "None",
    "value": "NONE",
    "description": "No role is assigned, this user will have the default permissions",
    "requiresReporting": false,
    "permissions": [],
    "isAdmin": false
}
